import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { StatusService } from '../services/status.service';

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {
  private activeRequestCount = 0;

  constructor(private statusService: StatusService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.activeRequestCount++;
    this.statusService.isLoading = true;
    return next.handle(request).pipe(
      finalize(() => {
        this.activeRequestCount--;
        if (this.activeRequestCount === 0) {
          this.statusService.isLoading = false;
        }
      }),
    );
  }
}
